import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",

    width: "760px",
    maxHeight: "90vh",
    minHeight: "220px",
    padding: "24px 40px 0px 40px",
    fontFamily: "Manrope !important",

    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    overflowY: "hidden",
    overflowX: "hidden",
    borderRadius: "8px",

    top: "50%",
    left: "50%",
    transform: `translate(-50%, -50%)`,
    position: "absolute",

    [theme.breakpoints.down("sm")]: {
      width: "85vw",
    },
  },
  containerReview: {
    // width: "1040px",
    width: "85vw !important",
  },

  header: {
    width: "100%",
  },
  titleClose: {
    marginBottom: "24px",
  },
  title: {
    color: "#344054",
    fontFamily: "Manrope !important",
    fontSize: "20px",
    fontWeight: 700,
  },
  filenameContainer: {
    marginRight: "33px",
    width: "fit-content",
  },
  filename: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 500,
    // marginRight: "16px",
  },
  fileLastUpload: {
    color: "#667085",
    fontWeigth: 400,
    fontSize: "12px",
  },
  uploadButton: {
    border: "1px solid rgba(48, 140, 219, 0.7)",
  },
  fileInput: {
    display: "none",
  },
  button: {
    cursor: "pointer",
  },

  section: {
    width: "100%",
    height: "100%",
  },
  content: {
    width: "100%",
  },
  errorWarningContainer: {
    marginTop: "24px",
  },
  errorWarningSection: {
    borderRadius: "8px",
    padding: "0px 8px",
    height: "28px",
    width: "fit-content",
    "& span": {
      color: "#667085",
      fontSize: "13px",
      fontWeight: 500,
      marginLeft: "13px",
      marginRight: "7px",
    },
  },
  errorSection: {
    backgroundColor: "#FEF3F2",
    marginBottom: "8px",
  },
  warningSection: {
    backgroundColor: "#FFFAEB",
  },

  grid: {
    overflowY: "auto",
    width: "100%",
    height: "fit-content",
    maxHeight: "calc(90vh - 25vh)",
    margin: "24px 0px 40px 0px",
    "& .shipeezi-new-grid-component table thead tr th": {
      textAlign: "left !important",
    },
    "& .shipeezi-new-grid-component table .tr-header th:first-child": {
      paddingLeft: "4px",
    },
    "& .shipeezi-new-grid-component .MuiTableContainer-root": {
      overflowX: "initial",
    },
  },
  priceInput: {
    width: "120px",
    marginLeft: "-32px",
  },
  priceInputCurrency: {
    minWidth: "145px",
  },
  exclamation: {
    marginLeft: "9px",
    marginTop: "3px",
  },

  footer: {
    backgroundColor: "#F7F7F9",
    height: "72px",
    width: "calc(100% + 80px)",
    display: "flex",
    alignItems: "center",
    padding: "0px 40px",
  },
  ml10: {
    marginLeft: "10px",
  },
  downloadTemplateButton: {
    backgroundColor: "rgba(242, 244, 247, 1)",
    padding: "8.5px 16px",
    borderRadius: "8px",
  },
  downloadTemplateText: {
    color: "rgba(48, 140, 219, 1)",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
  },
  actionButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

export default styles;
